<template>
  <div
    class="cpt-chat-text-area flex flex-col justify-center h-fit items-start bg-op-s2 rounded-[5px]"
  >
    <textarea
      ref="textarea"
      type="text"
      autocomplete="off"
      :value="value"
      :placeholder="placeholder"
      :maxlength="autoClip ? maxLength : undefined"
      spellcheck="false"
      :rows="rows"
      @input="handleInput"
      @blur="handleBlur"
      :disabled="disabled"
    ></textarea>
    <div
      v-if="maxLength"
      class="form-side-text-area-count flex justify-end items-center gap-[6px] self-stretch px-[12px] py-[7px] text-[12px] font-medium leading-[16px]"
      :class="[isOutRange ? 'text-er-tx' : 'text-tx-3']"
    >
      {{ `${value.length}/${maxLength}` }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatTextarea',
  props: {
    value: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: '',
    },
    rows: {
      type: Number,
      default: undefined,
    },
    autoClip: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isOutRange() {
      return this.value.length > this.maxLength;
    },
  },
  watch: {
    value: {
      handler() {
        this.adjustHeight();
      },
    },
    isOutRange: {
      handler() {
        this.$emit('outRange', this.isOutRange);
      },
    },
  },
  mounted() {
    this.adjustHeight();
  },
  methods: {
    handleInput(e) {
      this.$emit('input', e.target.value);
    },
    handleBlur() {
      this.$emit('blur');
    },
    focus() {
      this.$refs?.textarea?.focus();
    },
    blur() {
      this.$refs?.textarea?.blur();
    },
    adjustHeight() {
      // 如果手动规定了展示的行数则不进行调整
      if (this.rows) return;
      const textarea = this.$refs?.textarea;
      if (!textarea) return;
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
  },
};
</script>

<style lang="scss">
.cpt-chat-text-area {
  textarea {
    margin: 9px 12px;
    width: calc(100% - 24px);
    height: fit-content;
    min-height: 48px;
    border: none;
    outline: none;
    resize: none;
    background: transparent;
    color: $d-tx-2;
    font-size: 14px;
    line-height: normal;
    letter-spacing: 0.14px;
    &::placeholder {
      color: $d-tx-4;
    }
  }
}
</style>
